module.exports = __webpack_public_path__ + "static/q4answer2_beach_wishmas-731dcff93abc6d10e8f0fe3966302622.jpg";